module Meevo.Plugins.Register {
    "use strict";

    export class CashPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Cash, registerContext, "cashPayments", Register.RegisterSectionCatTypeEnum.Payment);
        }

        reset() {
            let paymentType = _.findWhere(this.registerContext.paymentTypes, { paymentCategory: Model.PaymentCategoryEnum.Cash });
            this.payment = {
                paymentTypeId: paymentType.id, 
                amount: 0,
                paymentCategory: Model.PaymentCategoryEnum.Cash
            };
        }

        public addPayment() {
            if (this.registerContext.isCreditMode) {
                this.registerContext.setChangeDueAsCash = true;
                this.registerContext.calculateCashRounding();
                this.reset();
                this.registerContext.finishSection().then(() => {
                    if (this.registerContext.isCreditMode) {
                        this.registerContext.selectSection(RegisterSectionTypeEnum.ChangeOptions);
                    }
                });
            }
            else {
                super.addPayment();
            }
        }
    }

}